export const ADD_TYPING="app/conversationsTyping/ADD_TYPING"
export const REMOVE_TYPING="app/conversationsTyping/REMOVE_TYPING"
